import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        delay: { type: Number, default: 100 }
    }

    scroll(event) {
        // Only trigger if the event target is contained within this element
        if (event && !this.element.contains(event.target)) return;

        setTimeout(() => {
            const rect = this.element.getBoundingClientRect();
            const isVisible = (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );

            // Scroll into view only if it's not fully visible 
            // block: 'start' aligns it better within a scrollable modal
            if (!isVisible && rect.height > 0) {
                this.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, this.delayValue);
    }
}
